import {
    MAPPINGBANKFORPARTNER_SUCCESS,
    MAPPINGBANKFORPARTNER_FAILED,
    RESET_MAPPINGBANKFORPARTNER,
    LOADING_MAPPINGBANKFORPARTNER,
    NETWORK_ERROR_MAPPINGBANKFORPARTNER
} from "../types/index";

import { partnerServices } from "../../config/axios";

const resetMappingBankListPartner = () => {
    return { type: RESET_MAPPINGBANKFORPARTNER };
};


const partnerMappingBanksReqList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_MAPPINGBANKFORPARTNER });
    await partnerServices
        .post("mappingBankForPartner", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(partnerMappingBankListsuccess(res.data));
                    break;
                default:
                    dispatch(partnerMappingBankListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_MAPPINGBANKFORPARTNER,
                payload: err
            });
        });
};


function partnerMappingBankListsuccess(data) {
    return {
        type: MAPPINGBANKFORPARTNER_SUCCESS,
        payload: data,
    };
}

function partnerMappingBankListFailed(data) {
    return {
        type: MAPPINGBANKFORPARTNER_FAILED,
        payload: data,
    };
}


export { resetMappingBankListPartner, partnerMappingBanksReqList }